// extracted by mini-css-extract-plugin
export var container = "_9d-0";
export var icon = "_9d-1";
export var text = "_9d-2";